import React from 'react';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Higher-order component that wraps any component with authentication
 * Makes it super easy to protect routes!
 *
 * Usage:
 * <Route path="/dashboard" component={withAuth(Dashboard)} />
 */
export function withAuth(
  Component: React.ComponentType<any>,
  requireFullAccount = true
): React.ComponentType<any> {
  return (props: any) => (
    <ProtectedRoute requireFullAccount={requireFullAccount}>
      <Component {...props} />
    </ProtectedRoute>
  );
}

/**
 * For guest users (limited access)
 */
export function withGuestAuth(
  Component: React.ComponentType<any>
): React.ComponentType<any> {
  return (props: any) => (
    <ProtectedRoute requireFullAccount={false}>
      <Component {...props} />
    </ProtectedRoute>
  );
}